import { render, staticRenderFns } from "./CareerDetailPage.vue?vue&type=template&id=2a77e7aa&"
import script from "./CareerDetailPage.vue?vue&type=script&lang=js&"
export * from "./CareerDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports